const filters =
{
  type1: 
  {
    text        : 'COMIDA RÁPIDA',
    id          : 'fastfood',
    visible     : true,
  },
  type2: 
  {
    text        : 'TÍPICA',
    id          : 'traditional',
    visible     : false,
  },
  type3: 
  {
    text        : 'PIZZERIA',
    id          : 'pizzashop',
    visible     : false,
  },
  type4: 
  {
    text        : 'MARISCOS',
    id          : 'seafood',
    visible     : false,
  },
  type5: 
  {
    text        : 'COSTEÑA',
    id          : 'coastfood',
    visible     : false,
  },
  type6: 
  {
    text        : 'FUSIÓN',
    id          : 'fusion',
    visible     : false,
  },
  type7: 
  {
    text        : 'CAFETERÍA',
    id          : 'coffee',
    visible     : true,
  },
  type8: 
  {
    text        : 'HELADERÍA',
    id          : 'icecream',
    visible     : false,
  },
  type9: 
  {
    text        : 'AMERICANA',
    id          : 'american',
    visible     : false,
  },
  type10: 
  {
    text        : 'MEXICANA',
    id          : 'mexican',
    visible     : true,
  },
  type11: 
  {
    text        : 'JAPONES',
    id          : 'japanese',
    visible     : true,
  },
  type12: 
  {
    text        : 'ITALIANA',
    id          : 'italian',
    visible     : false,
  },
  type13: 
  {
    text        : 'VENEZOLANA',
    id          : 'venezuelan',
    visible     : false,
  },
  type14: 
  {
    text        : 'ARABE',
    id          : 'arab',
    visible     : false,
  },
  type15: 
  {
    text        : 'GRIEGA',
    id          : 'greek',
    visible     : false,
  },
  type16: 
  {
    text        : 'HINDÚ',
    id          : 'indian',
    visible     : false,
  },
  type17: 
  {
    text        : 'VIETNAMES',
    id          : 'vietnamese',
    visible     : false,
  },
  type18: 
  {
    text        : 'CHINA',
    id          : 'china',
    visible     : false,
  },
  type19: 
  {
    text        : 'BISTRO',
    id          : 'bistro',
    visible     : true,
  },
  type20: 
  {
    text        : 'PUB',
    id          : 'pub',
    visible     : false,
  },
  type21: 
  {
    text        : 'BAR',
    id          : 'bar',
    visible     : false,
  },
  type22: 
  {
    text        : 'INTERNACIONAL',
    id          : 'international',
    visible     : false,
  },
}

export default filters;